export default __webpack_public_path__ + "2f14cbb7792a42471b1b64de35797d7a.ttf";